import { ActsLogo } from '@/components/ui/ActsLogo';
import { PoweredByCcms } from '@/components/ui/PoweredByCcms';
import { usePortalSettings } from '@/lib/settings';

/** Slim footer at the end of the content (never fixed). Not shown in the runner. */
export function SiteFooter() {
  const { settings } = usePortalSettings();
  const year = new Date().getFullYear();
  return (
    <footer className="proc-footer">
      <div className="proc-footer-inner">
        <div className="brand">
          <ActsLogo height={24} />
          <span>© {year} Acts Church</span>
        </div>
        {settings.supportText && <p className="proc-footer-support">{settings.supportText}</p>}
        <PoweredByCcms />
      </div>
    </footer>
  );
}
